module.exports = __webpack_public_path__ + "img/石林3_1.22301c51.jpg";